module.exports = __webpack_public_path__ + "img/LS.6b95ca5d.svg";